<div class="user-activity">
    <div *ngIf="!activities || activities.length === 0" class="text-center py-2">
        <h5 class="mb-0">No activities completed</h5>
        <p class="text-muted mb-0">The user still haven't completed any activities.</p>
    </div>
    
    <div *ngIf="activities && activities.length > 0" class="activity-list">
        <div *ngFor="let item of displayedActivities" class="activity-item pt-3">
            <div class="d-flex align-items-center justify-content-between gap-3 mb-2">
                <div class="flex-grow-1">
                    <div class="d-flex align-items-center gap-2 mb-2">
                        <span class="badge" [ngClass]="item.type === 'program' ? 'badge-program' : 'badge-workout'">
                            {{ item.type === 'program' ? 'Program' : 'Workout' }}
                        </span>
                        <span class="meta text-muted small">
                            {{ item.created_at | dateFormat:'dateTimeShort' }}
                        </span>
                    </div>
                    
                    <div class="title mb-2">
                        <ng-container *ngIf="item.type === 'training'">
                            {{ item.object['training_name'] }}
                        </ng-container>
                        <ng-container *ngIf="item.type === 'program'">
                            {{ item.object['program_name'] }}
                        </ng-container>
                    </div>

                    <div *ngIf="item.type === 'training' && item.object['program_name']" class="meta text-muted small mb-2">
                        Program: {{ item.object['program_name'] }}
                    </div>
                    
                    <button *ngIf="enableCommenting && !hasActivityNotes(item)" class="btn" (click)="openAddActivityCommentModal(item)">
                        <i class="ti ti-plus me-1"></i>Add comment
                    </button>
                </div>
                <img src="assets/common/ic_arrow_forward_m_size.svg" 
                     alt="Activity details" 
                     title="Activity details" 
                     class="link-icon" 
                     (click)="openActivityDetailsModal(item)">
            </div>

            <div *ngIf="hasActivityNotes(item)" class="activity-comment pt-2 px-3 pb-3 border-start border-primary border-3 rounded-0">
                <div class="d-flex justify-content-between align-items-center mb-1">
                    <div *ngIf="getLatestActivityNote(item)?.created_at" class="meta text-muted small">
                        {{ getLatestActivityNote(item)?.created_at | dateFormat:'dateTimeShort' }}
                    </div>
                    <div *ngIf="enableCommenting" class="actions d-flex gap-2">
                        <button class="btn btn-link p-0" title="Edit comment" (click)="openEditActivityCommentModal(item)">
                            <img src="assets/common/ic_edit.svg" alt="Edit comment">
                        </button>
                        <button class="btn btn-link p-0" title="Delete comment" (click)="deleteActivityComment(item)">
                            <img src="assets/common/ic_delete_destructive.svg" alt="Delete comment">
                        </button>
                    </div>
                </div>
                <div class="activity-comment-content">
                    {{ getLatestActivityNote(item)?.content }}
                </div>
            </div>
        </div>
    </div>
</div>

<app-user-training-activity-details-modal #trainingActivityDetailsModal></app-user-training-activity-details-modal>

<!-- Activity Details Modal -->
<div *ngIf="showActivityDetailsModal" 
     class="blur-modal-backdrop" 
     [class.fade-in]="!isClosingActivityDetailsModal" 
     [class.fade-out]="isClosingActivityDetailsModal"
     (click)="closeActivityDetailsModal()">
</div>

<div *ngIf="showActivityDetailsModal" 
     class="mantis-modal" 
     role="dialog" 
     aria-modal="true" 
     [class.modal-in]="!isClosingActivityDetailsModal" 
     [class.modal-out]="isClosingActivityDetailsModal">
    <div class="modal-dialog activity-details-modal" 
         (click)="$event.stopPropagation()" 
         style="max-width: 560px; max-height: 70vh; display: flex; flex-direction: column;">
        <div class="modal-header d-flex justify-content-between align-items-center" style="flex-shrink: 0;">
            <h5 class="mb-0 fw-bold">Activity details</h5>
            <button class="btn-close" (click)="closeActivityDetailsModal()" title="Close">
                <img src="assets/common/ic_x_s_size.svg" alt="Close">
            </button>
        </div>
        
        <div class="modal-body" style="padding: 1.5rem; overflow-y: auto; flex: 1; min-height: 0;">
            <div *ngIf="isLoadingActivityDetails" class="text-center py-4">
                <p class="text-muted">Loading activity details...</p>
            </div>

            <!-- Program Activity Details -->
            <div *ngIf="!isLoadingActivityDetails && activityDetails && activityDetailsType === 'program'" class="program-activity-details">
                <!-- Header Section -->
                <div class="mb-4">
                    <div class="d-flex align-items-center gap-2 mb-2">
                        <span class="badge badge-program">Program</span>
                        <span class="meta text-muted small">
                            {{ activityDetails.created_at | dateFormat:'dateTimeShort' }}
                        </span>
                    </div>
                    <div class="title fw-bold mb-2" style="font-size: 1.25rem;">
                        {{ activityDetails['program_name'] }}
                    </div>
                    <div *ngIf="activityDetails['parent_program_name']" class="text-muted small">
                        parent: {{ activityDetails['parent_program_name'] }}
                    </div>
                </div>

                <!-- Program Metrics Section -->
                <div class="mb-4">
                    <div class="row g-3">
                        <div *ngIf="activityDetails['number_of_weeks']" class="col-6">
                            <div class="workout-metric-card">
                                <div class="metric-icon">
                                    <img src="assets/activity/ic_weeks_circle.svg" alt="Weeks">
                                </div>
                                <div class="metric-content">
                                    <div class="metric-label">Weeks</div>
                                    <div class="metric-value">{{ activityDetails['number_of_weeks'] }}</div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="activityDetails['number_of_trainings']" class="col-6">
                            <div class="workout-metric-card">
                                <div class="metric-icon">
                                    <img src="assets/activity/ic_exercises_circle.svg" alt="Workouts">
                                </div>
                                <div class="metric-content">
                                    <div class="metric-label">Workouts</div>
                                    <div class="metric-value">{{ activityDetails['number_of_trainings'] }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Client Feedback Section -->
                <div class="mb-4" *ngIf="activityDetails['comment']">
                    <div class="fw-bold mb-2">Client feedback</div>
                    <div class="client-feedback-block pt-2 px-3 pb-2 border-start border-secondary border-3 rounded-0">
                        {{ activityDetails['comment'] }}
                    </div>
                </div>

                <!-- Weekly Breakdown Section -->
                <div class="mb-4" *ngIf="activityDetails['weeks'] && activityDetails['weeks'].length > 0">
                    <div class="fw-bold mb-3">Weekly Breakdown</div>
                    
                    <!-- Week Tabs -->
                    <ul class="nav nav-underline mb-3" role="tablist">
                        <li class="nav-item" role="presentation" *ngFor="let week of activityDetails['weeks']; let i = index">
                            <button class="nav-link" 
                                    [class.active]="selectedWeekIndex === i" 
                                    (click)="selectWeek(i)" 
                                    type="button">
                                {{ week.name }}
                            </button>
                        </li>
                    </ul>

                    <!-- Days for Selected Week -->
                    <div class="week-days" *ngIf="activityDetails['weeks'][selectedWeekIndex]">
                        <div 
                            *ngFor="let day of activityDetails['weeks'][selectedWeekIndex].days; let dayIndex = index" 
                            class="day-card mb-3 border rounded"
                            [class.bg-light]="day.is_rest_day"
                            [style.cursor]="!day.is_rest_day && day.exercises && day.exercises.length > 0 ? 'pointer' : 'default'"
                            (click)="!day.is_rest_day && day.exercises && day.exercises.length > 0 && toggleDayExpansion(selectedWeekIndex, dayIndex)"
                            style="transition: all 0.2s;">
                            <div class="p-3">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="flex-grow-1">
                                        <div class="fw-bold mb-1" *ngIf="day.title">{{ day.title }}</div>
                                        <div *ngIf="day.is_rest_day" class="text-muted">
                                            Rest day
                                        </div>
                                        <div *ngIf="!day.is_rest_day && day.name" class="fw-semibold">
                                            {{ day.name }}
                                        </div>
                                    </div>
                                    <i 
                                        *ngIf="!day.is_rest_day && day.exercises && day.exercises.length > 0"
                                        class="ti text-muted fs-5"
                                        [class.ti-chevron-down]="!isDayExpanded(selectedWeekIndex, dayIndex)"
                                        [class.ti-chevron-up]="isDayExpanded(selectedWeekIndex, dayIndex)"
                                        style="transition: transform 0.2s;">
                                    </i>
                                </div>
                            </div>
                            
                            <!-- Expanded Exercises Section -->
                            <div *ngIf="!day.is_rest_day && day.exercises && day.exercises.length > 0 && isDayExpanded(selectedWeekIndex, dayIndex)" 
                                 class="px-3 pb-3">
                                <div class="workout-details-list">
                                    <div *ngFor="let exercise of day.exercises" class="exercise-item mb-3">
                                        <div class="exercise-name fw-bold mb-2">
                                            {{ exercise.name }}
                                        </div>
                                        <div class="exercise-sets">
                                            <div *ngFor="let entry of exercise.entries" class="set-item mb-1">
                                                <span class="set-label">Set {{ entry.set_number }} / Rnd {{ entry.round_number }}:</span>
                                                <span *ngIf="entry.number_of_reps">{{ entry.number_of_reps }} reps</span>
                                                <span *ngIf="entry.number_of_reps && (entry.weight_in_kilograms_float || entry.time_in_seconds)"> • </span>
                                                <span *ngIf="entry.weight_in_kilograms_float">{{ entry.weight_in_kilograms_float | weightKg }} kg</span>
                                                <span *ngIf="entry.weight_in_kilograms_float && entry.time_in_seconds"> • </span>
                                                <span *ngIf="entry.time_in_seconds">{{ formatTime(entry.time_in_seconds) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Activity Comment Modal -->
<div *ngIf="showActivityCommentModal" 
     class="blur-modal-backdrop" 
     [class.fade-in]="!isClosingActivityCommentModal" 
     [class.fade-out]="isClosingActivityCommentModal">
</div>

<div *ngIf="showActivityCommentModal" 
     class="mantis-modal" 
     role="dialog" 
     aria-modal="true" 
     [class.modal-in]="!isClosingActivityCommentModal" 
     [class.modal-out]="isClosingActivityCommentModal">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
        <div class="modal-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0 fw-bold">{{ isEditingActivityComment ? 'Edit comment' : 'Add comment' }}</h5>
            <button class="btn-close" (click)="closeActivityCommentModal()" title="Close">
                <img src="assets/common/ic_x_s_size.svg" alt="Close">
            </button>
        </div>
        
        <div class="modal-body">
            <div *ngIf="currentActivity" class="mb-4">
                <div class="d-flex align-items-center gap-2 mb-1">
                    <span class="badge" [ngClass]="currentActivity.type === 'program' ? 'badge-program' : 'badge-workout'">
                        {{ currentActivity.type === 'program' ? 'Program' : 'Workout' }}
                    </span>
                    <span class="text-muted small">
                        {{ currentActivity.created_at | dateFormat:'dateTimeShort' }}
                    </span>
                </div>
                <div class="fw-bold">{{ currentActivity.program_name ?? currentActivity.training_name }}</div>
            </div>

            <form #activityCommentForm="ngForm" (ngSubmit)="confirmActivityComment(activityCommentForm)">
                <label class="form-label">Comment</label>
                <textarea class="form-control" 
                          name="activityComment" 
                          rows="4"
                          required
                          [(ngModel)]="editedActivityComment" 
                          placeholder="Enter your text here" 
                          [class.is-invalid]="showActivityCommentError"></textarea>
                <div class="invalid-feedback d-block" *ngIf="showActivityCommentError">
                    Please enter your comment.
                </div>
            </form>
        </div>
        
        <div class="modal-footer d-flex justify-content-end gap-2">
            <button class="btn btn-outline-secondary" (click)="closeActivityCommentModal()">Cancel</button>
            <button class="btn btn-primary" (click)="confirmActivityComment(activityCommentForm)">Confirm</button>
        </div>
    </div>
</div>

